<template>
    <el-select
      ref="select"
      :value="value"
      @change="onChange"
      @visible-change="onVisibleChange"
       v-bind="$attrs"
    >
      <el-option
        v-for="item in showOptions"
        :key="item[valueKey]"
        :label="item[labelKey]"
        :value="item[valueKey]"
      >
      </el-option>
    </el-select>
</template>

<script>
// 此组件用来解决 el-select组件中选项数据过多时导致的滚动卡顿等性能问题，默认只渲染已选择过的选项，通过监听下拉框的显示隐藏事件，在下拉框显示时才将选项数据赋值给组件，从而减少不必要的渲染，提高性能。
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [String, Number, Object, Array],
    options: {
      type: Array,
      default: () => [],
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    }
  },
  data() {
    return {
        showOptions:[]
    }
  },
  watch:{
    value:{
      handler(v){
        let hasOpt = this.showOptions.find(opt => opt[this.valueKey] === v)
        if(!hasOpt && this.showOptions.length != this.options.length){
            this.initOptions();
        }
      },
      deep:true
    }
  },
  computed: {

  },
  created(){
    this.initOptions();
  },
  methods: {
    initOptions(){
      if (typeof this.value !== 'number' && !this.value){
        this.showOptions = []
        return
      }
      const values = this.$attrs.multiple && Array.isArray(this.value)
        ? this.value
        : [this.value];
      if (!values.length){
        this.showOptions = []
        return
      };
      let options = values.map(v => this.options.find(opt => opt[this.valueKey] === v)).filter(Boolean);
      this.showOptions = options;
    },
    onChange(val) {
      this.$emit('change', val);
    },
    onVisibleChange(visible) {
        if(visible){
            this.showOptions = this.options
        }else{
            this.initOptions();
        }
    }
  }
};
</script>